import { COMMON_MENU_ITEMS, PERMISSIONS, WALLET_TYPES } from '@basqet-dashboard/common/config';

/**
 * NOTE: BEFORE ADDING A NEW MENU ITEM, PLEASE READ THIS:
 * Each menu item can have a permission associated with it
 * This permission is the minimum permission required to see the menu item
 * If a user has multiple permissions for the same menu item, the one with the lowest permission will be used to determine what screen to show
 * If the menu does not need a permission, it will be shown to all users, omit the permission field
 * If the menu item has tabs, the tabs will also have permissions associated with them
 * The same logic applies to tabs, if a user has multiple permissions for the same tab, the one with the lowest permission will be used to determine what screen to show
 */
import { SETTING_TABS } from './settings';
const MENU_ITEMS = [
  {
    name: 'Onboarding',
    path: '/onboard',
    hidden: true,
    pageTitle: {
      normal: 'Welcome,',
      cursive: ''
    }
  },
  {
    name: 'Freelancer Verification',
    path: '/onboard/freelancer',
    hidden: true,
    pageTitle: {
      normal: 'Freelancer',
      cursive: 'Verification'
    }
  },
  {
    name: 'Corporate Non-Financial Verification',
    path: '/onboard/corporate_non_fi',
    hidden: true,
    pageTitle: {
      normal: 'Corporate Non-Financial Institution',
      cursive: 'Verification'
    }
  },
  {
    name: 'Corporate Financial Verification',
    path: '/onboard/corporate_fi',
    hidden: true,
    pageTitle: {
      normal: 'Corporate Financial Institution',
      cursive: 'Verification'
    }
  },
  // useNavBar matches with `pathname.includes(path)` for hasSubRoutes entries and
  // returns the first hit, so this must precede the COMMON_MENU_ITEMS
  // `/transactions` entry. The trailing slash keeps it off the list page itself:
  // '/transactions/8842'.includes('/transactions/') is true, '/transactions' is not.
  {
    name: 'Transaction details',
    path: '/transactions/',
    permission: PERMISSIONS.TRANSACTIONS_VIEW,
    hasSubRoutes: true,
    breadcrumb: [{ label: 'Transactions', to: '/transactions' }, { label: 'Transaction details' }],
    hidden: true
  },
  ...COMMON_MENU_ITEMS,
  {
    name: 'Payout',
    path: '/payouts',
    permission: PERMISSIONS.PAYOUTS_VIEW,
    pageTitle: {
      normal: 'Your',
      cursive: 'Payouts'
    },
    tabs: WALLET_TYPES,
    hasSubRoutes: true,
    hidden: false
  },
  {
    name: 'Conversions',
    path: '/conversions',
    permission: PERMISSIONS.WALLET_CONVERSIONS_VIEW,
    pageTitle: {
      normal: 'Your',
      cursive: 'Conversions'
    },
    tabs: WALLET_TYPES,
    hasSubRoutes: true,
    hidden: false,
    cta: {
      label: 'Convert',
      target: '/conversions/convert',
      permission: PERMISSIONS.WALLET_CONVERSIONS_MANAGE
    }
  },
  {
    name: 'Payment Links',
    path: '/payment-links',
    permission: PERMISSIONS.PAYMENT_LINKS_VIEW,
    pageTitle: {
      normal: 'Payment',
      cursive: 'Links'
    }
  },
  {
    name: 'Developers',
    path: '/api',
    permission: PERMISSIONS.DEVELOPER_TAB_VIEW,
    pageTitle: {
      normal: 'Developer',
      cursive: 'settings'
    },
    hasDivider: true
  },
  {
    name: 'Settings',
    path: '/settings',
    pageTitle: {
      normal: 'Account',
      cursive: 'settings'
    },
    tabs: SETTING_TABS
  }
];

export { MENU_ITEMS };
